import PanelSteps from './PanelSteps'
import Step from './Step'
;(PanelSteps as PanelStepsComponent).Step = Step

export { usePanelSteps } from './ContextProvider'

export default PanelSteps as PanelStepsComponent
